import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import Select from "react-select"
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Badge,
  Button,
  CardTitle,
  Label,
  CardSubtitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";

import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation";
// Redux
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import cellEditFactory from "react-bootstrap-table2-editor";

import showNotification from "../../helpers/show_notification";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { postSubmitForm } from "../../helpers/forms_helper";
import preloader from "../../helpers/preloader";
import { mapUnits } from "../../helpers/units";

const BranchProducts = (props) => {
  const [openingModal, setOpeningModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const { SearchBar } = Search;
  const handleValidOpening = async (e, v) => {
    const data_to_send = {
      branch_id: selectedBranch.branch_id,
      product_id: selectedRow.product_id,
      quantity: v.quantity,
    };
    // console.log(data_to_send);
    let url =
      process.env.REACT_APP_BASEURL + "branchproductinventories/opening";
    const response = await postSubmitForm(url, data_to_send);
    if (response && response.status === 1) {
      setOpeningModal(!openingModal);
      showNotification(response.message, "Success");
    } else {
      showNotification(response.message, "Error");
    }
  };
  const refForForm = useRef(null);
  useEffect(() => {
    loadAllStores();
  }, []);
  const refContainer = useRef(null);

  const [allBranches, setAllBranchStores] = useState([]);
  const [allSubStores, setAllSubStores] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState();
  const loadAllStores = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const res1 = response.data.filter((store) =>store.type === "Branch" || store.type === "CENTRAL KITCHEN STORE");
      const res2 = response.data.filter((store) => store.type === "Sub Store")
      setAllBranchStores(res1);
      res2.forEach((store)=>{
        return (
          store.label=store.name,
          store.value=store._id
          )})
      setAllSubStores(res2);
    } else {
      showNotification(response.message, "Error");
    }
  };
  const [branchProducts, setBranchProducts] = useState([]);
  const loadBranchProducts = async (branch_id) => {
    preloader(true);
    let url = process.env.REACT_APP_BASEURL + "branchproducts/get_mapping";
    let response = await postSubmitForm(url, { branch_id: branch_id });
    if (response.status === 1) {
      setBranchProducts(response.data);
      preloader(false);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };

  const applyLocalMappingUpdate = (product, type, store) => {
    setBranchProducts((prev) =>
      prev.map((row) => {
        if (String(row.product_id) !== String(product.product_id)) return row;
        if (type === "add") {
          return { ...row, is_selected: true };
        }
        if (type === "edit") {
          const next = {
            ...row,
            is_selected: true,
            threshold: product.threshold,
            max_order_limit: product.max_order_limit,
            max_order_limit_weekly: product.max_order_limit_weekly,
          };
          if (store) {
            next.sub_store = store.label || store.name || row.sub_store;
            next.sub_store_id = store.value || store._id || row.sub_store_id;
          }
          return next;
        }
        if (type === "delete") {
          return {
            ...row,
            is_selected: false,
            sub_store: null,
            sub_store_id: null,
          };
        }
        return row;
      })
    );
  };

  const handleProductAction = async (product, type) => {
    const store_id = selectedStore?.value || selectedStore?._id || product.sub_store_id;
    const data_to_send = {
      branch_id: selectedBranch.branch_id,
      sub_store_id: store_id,
      branch_name: selectedBranch.branch_name,
      product_id: product.product_id,
      threshold: product.threshold,
      max_order_limit: product.max_order_limit,
      max_order_limit_weekly: product.max_order_limit_weekly,
      action: type,
    };

    let url = process.env.REACT_APP_BASEURL + "branchproducts/set_mapping";
    const response = await postSubmitForm(url, data_to_send);
    if (response && response.status === 1) {
      applyLocalMappingUpdate(product, type, selectedStore);
      if (type === "add") showToast(props.t("Branch product added."));
      if (type === "edit") showToast(props.t("Branch product updated."));
      if (type === "delete") showToast(props.t("Branch product deleted."));
      setSelectedStore();
      setSelectedRow();
      setEditSubStoreModal(false);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [subStoreModal, setSubStoreModal] = useState(false)
  const [editSubStoreModal, setEditSubStoreModal] = useState(false)
  const [selectedStore, setSelectedStore] = useState()
  function selectStoreFormatter(cell, row) {
    if (row.sub_store !=="" && row.sub_store !== undefined && row.sub_store !== null) {
      return (
        <>
        {/* {row.sub_store}&nbsp; &nbsp; */}
          <div className="container d-flex justify-content-between">
          <div>{row.sub_store && row.sub_store}</div>
          <div>
          <span className="text-info">
                <i
                  className="bx bxs-edit font-size-15"
                  title="Click to Edit"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setSelectedRow(row);
                    setSelectedStore({label:row.sub_store,value:row.sub_store_id})
                    setEditSubStoreModal(!editSubStoreModal)
                  }}
                ></i>
              </span>
          </div>
          </div>
        </>
      ); 
    }else{
      return (
      <>
     {row.is_selected && (
        <span className="text-info" style={{ fontSize: "25px", color: "blue", fontWeight: "bold" }} >
        <i className="bx bx-plus"
          onClick={() => {
            setSelectedRow(row);
            setSubStoreModal(!subStoreModal)
          }}
        />
        </span>
      )}
      </>
      )
    }
  }
  const columns = [
    {
      dataField: "product_id",
      hidden: true,
      csvExport: false,
    },
    {
      dataField: "product_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      csvExport: false,
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
    {
      text: props.t("Name"),
      dataField: "name",
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      text: props.t("Formula"),
      dataField: "unit_levels",
      formatter:(cell,row)=>{
        return mapUnits(row.unit_levels)
      },
      sort: true,
      csvFormatter: (cell, row) => {
        if (row.unit_levels.length > 1) {
          return row.unit_levels.slice(1).map((unit, ind) => {
            const prevUnit = row.unit_levels[ind]?.unit;
            return `1 ${prevUnit} = ${unit.value} ${unit.unit}`;
          }).join('; ');
        } else {
          return row.unit_levels.map(unit => unit.unit).join(', ');
        }
      },
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "section",
      text: props.t("Section"),
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    },

    {
      dataField: "is_premium_product",
      text: props.t("Premium Product"),
      sort: true,
      editable: false,
      formatter: (cel, row) => {
        return row.is_premium_product ? "Yes" : "No";
      },
      csvFormatter: (cell, row) => {
        return row.is_premium_product?"Yes" : "No";
    },
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    },
    {
      dataField: "threshold",
      text: props.t("Threshold"),
      sort: true,
      editable: true,
      validator: (newValue, row, column) => {
        if (isNaN(newValue)) {
          return {
            valid: false,
            message: 'value should be numeric'
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: 'Value should greater than 0'
          };
        }
        return true;
      },
      formatter: (cell, row) => {
        if (
          row.threshold !== undefined &&
          row.threshold !== null &&
          row.threshold !== ""
        ) {
          return row.threshold + " " + row.unit_for_threshold;
        } else {
          return "";
        }
      },
      csvFormatter: (cell, row) => {
        return row.threshold+" "+row.unit_for_threshold;
    },
      attrs: { title: "Click to Edit" },
      style: { cursor: "pointer" },
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
    {
      dataField: "sub_store",
      text: props.t("Sub Store"),
      sort: true,
      hidden:true,
      editable: false,
      // align: (cell, row, rowIndex, colIndex) => {
      //   return 'center';
      // },
      style: { cursor: "pointer" },
      formatter: selectStoreFormatter,
      csvFormatter: (cell, row) => {
        return row.sub_store ? row.sub_store :""
     },
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      dataField: "max_order_limit",
      text: props.t("Max Order Limit"),
      sort: true,
      formatter: (cell, row) => {
        if (
          row.max_order_limit !== undefined &&
          row.max_order_limit !== null &&
          row.max_order_limit !== ""
        ) {
          return row.max_order_limit + " " + row.unit_for_max_order;
        } else {
          return "";
        }
      },
      validator: (newValue, row, column) => {
        if (isNaN(newValue)) {
          return {
            valid: false,
            message: 'value should be numeric'
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: 'Value should greater than 0'
          };
        }
        return true;
      },
      csvFormatter: (cell, row) => {
        return row.max_order_limit+" "+row.unit_for_max_order;
      },
      editable: true,
      type: "number",
      attrs: { title: "Click to Edit" },
      style: { cursor: "pointer" },
      align: (cell, row, rowIndex, colIndex) => {
        return "center";
      },
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
    {
      dataField: "max_order_limit_weekly",
      text: props.t("Weekly Order Limit"),
      sort: true,
      formatter: (cell, row) => {
        if (
          row.max_order_limit_weekly !== undefined &&
          row.max_order_limit_weekly !== null &&
          row.is_premium_product
        ) {
          return row.max_order_limit_weekly + " " + row.unit_for_max_order;
        } else {
          return "";
        }
      },
      editable: (cell, row) => {
        return row.is_premium_product ?  true : false;
      },
      csvFormatter: (cell, row) => {
        return  row.is_premium_product ? row.max_order_limit_weekly+" "+row.unit_for_max_order: " ";
      },
      type: "number",
      attrs: { title: "Click to Edit" },
      style: { cursor: "pointer" },
      align: (cell, row, rowIndex, colIndex) => {
        return "center";
      },
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
    {
      text: props.t("Action"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
      editable: false,
      formatter: (cell, row) => {
        if (row.is_selected) {
          return (
            <>
              <button
                class="btn btn-secondary btn-sm btn btn-primary mr-2"
                onClick={() => {
                  handleProductAction(row, "edit");
                }}
              >
                {props.t("Update")}
              </button>
              <button
                class="btn btn-danger btn-sm btn btn-primary mr-2"
                onClick={() => {
                  handleProductAction(row, "delete");
                }}
              >
                {props.t("Delete")}
              </button>

              {/* <button
                  class="btn btn-success btn-sm btn btn-primary "
                  onClick={() => {
                    setSelectedRow(row);
                    setOpeningModal(!openingModal);
                  }}
                >
                  {props.t("Opening")}
                </button> */}
            </>
          );
        } else {
          return (
            <button
              class="btn btn-primary btn-sm btn btn-primary"
              onClick={() => {
                handleProductAction(row, "add");
              }}
            >
              {props.t("Add")}
            </button>
          );
        }
      },
      csvExport: false,
    },
    {
      dataField: "category",
      text: props.t("Category"),
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const pagination_options = {
    sizePerPage: 50,
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "Next page",
    prePageTitle: "Previous page",
    firstPageTitle: "First page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
  };
  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.is_unsaved) {
      style.backgroundColor = "#ffcc00";
    } else if (row.is_selected) {
      style.backgroundColor = "#c7dced";
    } else {
      style.backgroundColor = "#dadada";
    }

    return style;
  };

  const showToast = (message_to_show) => {
    var ele = document.getElementsByName("toastType");
    var position = document.getElementsByName("positions");
    var toastType = "info";
    var title = "";
    var message = message_to_show;

    //Close Button
    var closeButton = true;

    //Progressbar
    var progressBar = true;

    //Duplicates
    var preventDuplicates = false;

    //Newest on Top
    var newestOnTop = true;

    //position class
    var positionClass = "toast-bottom-right";

    //show duration
    var showDuration = 200;

    //Hide duration
    var hideDuration = 1000;

    //timeout
    var timeOut = 2000;

    //extended timeout
    var extendedTimeOut = 1000;

    toastr.options = {
      positionClass: positionClass,
      timeOut: timeOut,
      extendedTimeOut: extendedTimeOut,
      closeButton: closeButton,
      progressBar: progressBar,
      preventDuplicates: preventDuplicates,
      newestOnTop: newestOnTop,
      showDuration: showDuration,
      hideDuration: hideDuration,
    };

    // setTimeout(() => toastr.success(`Settings updated `), 300)
    //Toaster Types
    if (toastType === "info") toastr.info(message, title);
    else if (toastType === "warning") toastr.warning(message, title);
    else if (toastType === "error") toastr.error(message, title);
    else toastr.success(message, title);
  };

  const handleSelectStore = (data, changedValue) => {
    // select logic 
    if (changedValue.action === "select-option") {
     
      setSelectedStore(data);
    }
    if (changedValue.action === 'remove-value') {
      let UpdatedSelectedItem = selectedStore?.filter(item => item.label !== changedValue.removedValue.label);
      setSelectedStore(UpdatedSelectedItem);
    }

  }

  const handleSubmitSelectedStore = async () =>{
    const data_to_send = {
      branch_id: selectedBranch.branch_id,
      sub_store_id: selectedStore._id || selectedStore.value,
      branch_name: selectedBranch.branch_name,
      product_id: selectedRow.product_id,
      threshold: selectedRow.threshold,
      max_order_limit: selectedRow.max_order_limit,
      max_order_limit_weekly: selectedRow.max_order_limit_weekly,
      action: "edit",
    };

    let url = process.env.REACT_APP_BASEURL + "branchproducts/set_mapping";
    const response = await postSubmitForm(url, data_to_send);
    if (response && response.status === 1) {
      applyLocalMappingUpdate(selectedRow, "edit", selectedStore);
      setSubStoreModal(false)
      setSelectedRow()
      setSelectedStore()
      showToast(props.t(response.message));
    } else {
      showNotification(response.message, "Error");
    }
  }
  const handleUpdateSelectedStore = () =>{
    handleProductAction(selectedRow, "edit" )
  }


  const MyExportCSV = (props) => {
    const handleClick = () => {
      // passing my custom data
      props.onExport(branchProducts.filter((r) => r.is_selected));
    };
    return (
      <div>
        <button className="btn btn-success" onClick={handleClick}>
          Export Selected to CSV
        </button>
      </div>
    );
  };

  
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={props.t("Store")}
            breadcrumbItem={props.t("Branch Products")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm ref={refForForm}>
                    <CardTitle>{props.t("Branch Products")}</CardTitle>
                    <CardSubtitle className="mb-3">
                      {props.t(
                        "Select a branch to add/update/delete a branch product"
                      )}
                    </CardSubtitle>
                    <Row>
                      <Col lg={6}>
                        <AvField
                          name="branch"
                          // label={props.t("Select Branch")}
                          type="select"
                          validate={{ required: { value: true } }}
                          errorMessage={props.t("Branch cannot be empty")}
                          onChange={(e) => {
                            const selectedIndex =
                              e.target.options.selectedIndex;

                            setSelectedBranch({
                              branch_id: e.target.value,
                              branch_name:
                                e.target.options[selectedIndex].getAttribute(
                                  "name"
                                ),
                            });
                            loadBranchProducts(e.target.value);
                          }}
                        >
                          <option value="">
                            {props.t("-- Select Branch --")}
                          </option>
                          {allBranches &&
                            allBranches.map((e) => (
                              <option key={e._id} value={e._id} name={e.name}>
                                {e.name}
                              </option>
                            ))}
                        </AvField>
                      </Col>
                    </Row>
                    {/* <Button type="submit">Submit</Button> */}
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>{props.t("Branch Products")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t(
                      "View all branch products for selected branch here"
                    )}
                  </CardSubtitle>
                  <ToolkitProvider
                    keyField="product_id"
                    data={branchProducts && branchProducts}
                    columns={columns}
                    search
                    exportCSV={ {
                      fileName: 'branch_products.csv',
                    }}
                  >
                    {(propst) => (
                      <div>
                           <Row>
                          <Col lg={4}>
                            <SearchBar
                              {...propst.searchProps}
                              style={{ width: "300px" }}
                            />
                          </Col>
                          <Col lg={4}>&nbsp;</Col>
                          <Col lg={4} className="text-right">
                            <MyExportCSV {...propst.csvProps} />
                          </Col>
                        </Row>
                        <BootstrapTable
                          {...propst.baseProps}
                          pagination={paginationFactory(pagination_options)}
                          noDataIndication={props.t("No data to display.")}
                          striped
                          hover
                          condensed
                          rowStyle={rowStyle}
                          cellEdit={cellEditFactory({
                            mode: "click",
                            blurToSave: true,
                            afterSaveCell: (
                              oldValue,
                              newValue,
                              row,
                              column
                            ) => {
                              // row.is_unsaved = true;
                              // let arr = branchProducts.filter((product)=>product.product_id === row.product_id);
                              // arr[0].is_unsaved = true;
                              // setBranchProducts()
                              // let arr = extraData.filter(
                              //   (item) => item.batch !== row.batch
                              // );
                              // console.log(row);
                            },
                          })}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
          

               {/* Sub Store Modal  */}
               <Modal
            size="md"
            isOpen={subStoreModal}
            toggle={() => setSubStoreModal(!subStoreModal)}
            onClosed={()=>setSelectedStore()}
          >
            <ModalHeader toggle={() => setSubStoreModal(!subStoreModal)}>
              {props.t("Select Sub Store")}
            </ModalHeader>
            <ModalBody>
              <AvForm onValidSubmit={handleSubmitSelectedStore}>
                <Row>

                  <Col lg={12}>
                    <Label>
                      {props.t("Sub Store")}
                    </Label>
                    <Select
                      options={allSubStores}
                      value={selectedStore}
                      onChange={(data, changedValue) => handleSelectStore(data, changedValue)}
                      closeMenuOnSelect={true}
                      classNamePrefix="select"
                      isMulti={false}
                      // className="basic-multi-select"
                    />
                  </Col>

                </Row>
                <Col lg={12}>
                                    <hr />
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("Add")}
                                        </Button>
                                      </div>
                                    </FormGroup>
                                  </Col>
              </AvForm>
            </ModalBody>
          </Modal>

           {/* Sub Store Edit Modal  */}
           <Modal
            size="md"
            isOpen={editSubStoreModal}
            toggle={() => setEditSubStoreModal(!editSubStoreModal)}
            onClosed={()=>setSelectedStore()}
          >
            <ModalHeader toggle={() => setEditSubStoreModal(!editSubStoreModal)}>
              {props.t("Update Sub Store")}
            </ModalHeader>
            <ModalBody>
              <AvForm onValidSubmit={handleUpdateSelectedStore}>
               {selectedRow&&(
                 <Row>

                 <Col lg={12}>
                   <Label>
                     {props.t("Sub Store")}
                   </Label>
                   <Select
                     options={allSubStores}
                     value={selectedStore && selectedStore}
            onChange={(data, changedValue) => handleSelectStore(data, changedValue)}
                     closeMenuOnSelect={true}
                     classNamePrefix="select"
                     isMulti={false}
                     // className="basic-multi-select"
                   />
                 </Col>

               </Row>
               )}
                <Col lg={12}>
                                    <hr />
                                    <FormGroup className="mb-0 text-center">
                                      <div>
                                        <Button
                                          type="submit"
                                          color="primary"
                                          className="mr-1"
                                        >
                                          {props.t("update")}
                                        </Button>
                                      </div>
                                    </FormGroup>
                                  </Col>
              </AvForm>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default withRouter(connect(null, {})(withNamespaces()(BranchProducts)));
